// Elv3ReviewSubmit.jsx
import React, { useState } from "react";
import {
  Box,
  Typography,
  Button,
  Alert,
  CircularProgress,
} from "@mui/material";
import { useHeaders } from "../HeadersContext";
import { CreateUpdateElv3 } from "../services/Elv3Service";

const Elv3ReviewSubmit = ({ finalJSON, onSubmitSuccess }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submissionResult, setSubmissionResult] = useState(null);
  const [error, setError] = useState(null);
  const { headers } = useHeaders();

  const handleSubmitReview = async () => {
    setIsSubmitting(true);
    setError(null);

    try {
      const response = await CreateUpdateElv3(finalJSON, headers);
      setIsSubmitting(false);

      if (response && response.elv3GroupGuid) {
        setSubmissionResult(response);
        // Pass the submission result to the parent component
        onSubmitSuccess(response);
      } else {
        throw new Error("Response is missing required elv3GroupGuid");
      }
    } catch (err) {
      console.error("Error submitting final JSON:", err);
      setError(err.message || "Failed to submit ELV3 inspection");
      setIsSubmitting(false);
    }
  };

  return (
    <Box p={2}>
      <Typography variant="h6" gutterBottom>
        Review Your Submission
      </Typography>

      {error && (
        <Alert severity="error" sx={{ my: 2 }}>
          {error}
        </Alert>
      )}

      <pre
        style={{
          backgroundColor: "#f0f0f0",
          padding: "1rem",
          maxHeight: "300px",
          overflow: "auto",
        }}
      >
        {JSON.stringify(finalJSON, null, 2)}
      </pre>

      {!submissionResult ? (
        <Box sx={{ mt: 2 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmitReview}
            disabled={isSubmitting}
            startIcon={
              isSubmitting ? (
                <CircularProgress size={20} color="inherit" />
              ) : null
            }
          >
            {isSubmitting ? "Submitting..." : "Submit Inspection"}
          </Button>
        </Box>
      ) : (
        <Box sx={{ mt: 2 }}>
          <Alert severity="success" sx={{ mb: 2 }}>
            Submission successful! ELV3 Group GUID:{" "}
            {submissionResult.elv3GroupGuid}
          </Alert>
          <Typography variant="body2" sx={{ mb: 2 }}>
            The inspection has been successfully created. You can now proceed to
            add defects.
          </Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={() => onSubmitSuccess(submissionResult)}
          >
            Proceed to Defect Creation
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default Elv3ReviewSubmit;
